/* tslint:disable */
import { withFormik } from 'formik'

/** @todo No @types for yup so have to require over import to skip TSC */
const Yup = require('yup')

/**
 *   Import
 *   - Components
 */
import { Props } from '../../../components/pages/Recover/Recover'
import { RecoverForm } from '../../../components/pages/RecoverForm/RecoverForm'

/**
 *   Variables types
 */
export type Values = {
  token: string;
  password: string;
  passwordConfirmation: string;
}

function equalTo(ref: any, msg: any) {
  return Yup.mixed().test({
    name: 'equalTo',
    exclusive: false,
    message: msg || '${path} must be the same as ${reference}',
    params: {
      reference: ref.path,
    },
    test: function(value: any) {
      return value === this.resolve(ref);
    },
  });
}
Yup.addMethod(Yup.string, 'equalTo', equalTo);

const withFormikComp = withFormik<Props, Values, Values>({
    displayName: 'RecoverForm',

    mapPropsToValues: (props) => {
        return {
            token: '',
            password: '',
            passwordConfirmation: '',
        }
    },

    /**
     * Form validation fields settings
     */
    validationSchema: Yup.object().shape({
        token: Yup.string(),
        password: Yup.string().required('Valid password is required').min(8, 'Password need min 8 characters'),
        passwordConfirmation: Yup.string().equalTo(Yup.ref('password'), "Passwords doesn't match"),
    }),

    /**
     * Form Options
     * @type {Boolean}
     */
    validateOnChange: true,

    /**
     * handle the submit form action
     * @param  {object} values [Email address filled by user]
     * @param  {function} props: {forgot} [Forgot action trigger passed on global state]
     */
    handleSubmit: (values, { props: { match, recoverpassword } }) => {
        values.token = match.params.token
        recoverpassword(values)
    },
})

export default withFormikComp(RecoverForm)




// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/RecoverForm/RecoverForm.tsx